import { OrderPaymentInstrument } from '~/lib/data-contract/salesforce';

type RewardEntry = {
    memberAccountNo: string;
    barcode: string;
};

export const extractRewardsStatusByBarcode = (
    paymentInstruments: OrderPaymentInstrument[] | undefined,
    paymentMethodId: string,
) => {
    const rewards: RewardEntry[] = [];

    if (!paymentInstruments) return rewards;

    for (const pi of paymentInstruments) {
        if (pi.paymentMethodId !== paymentMethodId) continue;
        if (typeof pi.c_payment_data !== 'string') continue;

        let parsed: RewardEntry[];

        try {
            parsed = JSON.parse(pi.c_payment_data);
        } catch {
            continue;
        }

        for (const entry of parsed) {
            rewards.push(entry);
        }
    }

    return rewards;
};
